module.exports = __webpack_public_path__ + "img/blackIdentity.b6209256.svg";